import { useEvent } from 'src/context/usePromoEvent';
import { EVENT_NAME } from '../helpers';
import dayjs from 'dayjs';
import { GameCategoryName } from 'src/constants/gameCategories';

export const useGetEvent = (): { name: GameCategoryName; dateEnd: number } | undefined => {
  const { eventActive } = useEvent();

  if (eventActive.eventDays)
    return {
      name: EVENT_NAME,
      dateEnd: dayjs('2026-05-04 23:59:59.000+00:00').unix()
    };

  return undefined;
};
